import {Component, computed, input} from '@angular/core';
import {FloatLabel} from 'primeng/floatlabel';
import {DatePicker} from 'primeng/datepicker';
import {FormControl, ReactiveFormsModule, Validators} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {MessageModule} from 'primeng/message';

@Component({
  selector: 'elcia-time-picker',
  imports: [
    FloatLabel,
    DatePicker,
    ReactiveFormsModule,
    TranslateModule,
    MessageModule,
  ],
  templateUrl: './time-picker.html',
  styleUrl: './time-picker.scss',
})
export class ElciaTimePicker {
  label = input<string>();
  control = input.required<FormControl<Date | null>>();
  isRequired = computed(() => this.control().hasValidator(Validators.required));
}
